import {
  gql 
} from "@apollo/client";

export const ADD_APPOINTMENTS = gql`
    mutation addAppointments(
      $id: Int
      $firstname: String!
      $lastname: String!
      $email: String!
      $phone: String!
      $appointmenttype: String!
      $timezone: String!
      $appointmentdate: String!
      $appointmentweek: String!
      $appointmenttime: String!
    ) {
      addAppointments(
            input: {
              id: $id
              firstname: $firstname
              lastname: $lastname
              email: $email
              phone: $phone
              appointmenttype: $appointmenttype
              timezone: $timezone
              appointmentdate: $appointmentdate
              appointmentweek: $appointmentweek
              appointmenttime: $appointmenttime
            }
        ) {
            code
            message
            content
        }
    }
`;

export const UPDATE_APPOINTMENTS = gql`
    mutation updateAppointments(
      $id: Int
      $firstname: String!
      $lastname: String!
      $email: String!
      $phone: String!
      $appointmenttype: String!
      $timezone: String!
      $appointmentdate: String!
      $appointmentweek: String!
      $appointmenttime: String!
    ) {
      updateAppointments(
            input: {
              id: $id
              firstname: $firstname
              lastname: $lastname
              email: $email
              phone: $phone
              appointmenttype: $appointmenttype
              timezone: $timezone
              appointmentdate: $appointmentdate
              appointmentweek: $appointmentweek
              appointmenttime: $appointmenttime
            }
        ) {
            code
            message
            content
        }
    }
`;

export const CANCEL_APPOINTMENTS = gql`
    mutation cancelAppointments(
      $id: Int
    ) {
      cancelAppointments(
          id: $id
        ) {
            code
            message
            content
        }
    }
`;

export const GET_APPOINTMENTS = gql`
    query getAppointments(
      $email: String!
      $phone: String!
    ) {
      getAppointments(
          email: $email
          phone: $phone
        ) {
            code
            message
            content
        }
    }
`;


export default {
  addAppointmentsMutation: ADD_APPOINTMENTS,
  cancelAppointmentsMutation: CANCEL_APPOINTMENTS,
  updatelAppointmentsMutation: UPDATE_APPOINTMENTS,
  getAppointmentsMutation: GET_APPOINTMENTS
};
